<template>
  <el-table-column v-bind="$attrs" :sort-method="sortName">
    <template slot-scope="scope">
      <div class="user-info">
        <initial-avatar v-bind="$attrs" :screen="screen" :avatarUrl="scope.row.photo_url" :userObject="$attrs.prop === 'composed' ? scope.row : scope.row[$attrs.prop]" :indx="scope.$index" />
        <div class="owner-info">
          <router-link :to="getDetailLink(scope.row)">
            <p>{{ name($attrs.prop === 'composed' ? scope.row : scope.row[$attrs.prop]) }}</p>
            <p>{{ scope.row.email }}</p>
          </router-link>
        </div>
      </div>
    </template>
  </el-table-column>
</template>

<script>
import { any, compose, propEq, propOr, both, is } from 'ramda'
import { TEACHER, STUDENT } from '@/constants/userRoles'
import InitialAvatar from '@/components/common/InitialAvatar'
export default {
  components: {
    InitialAvatar
  },
  props: {
    screen: {
      type: String,
      default: STUDENT
    }
  },
  data() {
    return {
      organizationId: this.$store.getters['organization/currentOrganizationId']
    }
  },
  computed: {},
  methods: {
    name(userObject) {
      if (is(String, userObject)) {
        return userObject
      }

      return userObject ? `${userObject.first_name} ${userObject.last_name}` : ''
    },
    userHasPendingInvites(userObject) {
      return compose(any(both(propEq('status', 'Pending'), propEq('role', TEACHER))), propOr([], 'pending_invitations'))(userObject)
    },
    getDetailLink(row) {
      if (this.screen === STUDENT) {
        return `/organization/${this.organizationId}/students/${row.id}`;
      }
      if (this.screen === 'branch')
        return `/organization/${row.id}/dashboard`;

      return ''
    },
    sortName(studentA, studentB) {
      // for screen branch we just compare by name branch
      if(this.screen === 'branch')
        return studentA.name.localeCompare(studentB.name);
      const nameAConstructable = studentA.first_name || studentA.last_name
      const nameBConstructable = studentB.first_name || studentB.last_name
      // Neu ca 2 deu co first name hoac last name
      if (nameAConstructable && nameBConstructable) {
        const nameA = studentA.first_name + ' ' + studentA.last_name
        const nameB = studentB.first_name + ' ' + studentB.last_name
        return nameA.localeCompare(nameB)
      } else if (nameAConstructable) {
        return 1
      } else if (nameBConstructable) {
        return -1
      } else {
        return studentA.email.localeCompare(studentB.email)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';
.user-info {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: $darker-blue;
  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .owner-info {
    span {
      font-weight: 500;
      font-size: 18px;
      color: $black;
    }
    p {
      font-weight: 500;
      font-size: 18px;
      text-transform: capitalize;
      color: $black;
      margin: 0;
      text-align: initial;
      display: flex;
      align-items: center;
      &:last-of-type {
        font-size: 14px;
        color: $light-blue-2;
        text-transform: none;
        line-height: 34px;
      }
      span {
        font-weight: normal;
        font-size: 11px;
        color: rgba(109, 122, 140, 0.5);
        padding-left: 3px;
        display: flex;
        align-items: center;
        i {
          font-size: 18px;
          vertical-align: text-bottom;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
